<app-buletine-control
  [cantariri]="tables$ | async"
  [cantaririLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
  (tableCallback)="getTableCallback($event)"
>
</app-buletine-control>
